export default __webpack_public_path__ + "static/media/car11.8bc7e4f9.jpg";